import { Phone, Mail, MapPin, Clock, Moon, ShieldCheck } from "lucide-react";
import { Logo } from "./Logo";
import { BIZ, NAV } from "@/content";
import { scrollToId } from "@/lib/smooth";

export const Footer = () => (
  <footer className="bg-[#0B1F42] pb-28 pt-20 text-white md:pb-10" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
      <p className="font-display text-[15vw] font-extrabold leading-[0.85] tracking-[-0.04em] text-white/[0.08] lg:text-[11rem]" aria-hidden="true">Plumberoo</p>
      <div className="mt-12 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo light />
          <p className="mt-5 max-w-xs text-sm text-white/75">{BIZ.legal}. Plumbing done right — first time, every time.</p>
          <p className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.16em]" data-testid="footer-licence">
            <ShieldCheck className="h-4 w-4 text-[#FF6B00]" /> Licence {BIZ.licence}
          </p>
        </div>
        <div className="space-y-3 text-sm text-white/85" data-testid="footer-contact">
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-[#FFB27A]">Contact</h4>
          <a href={BIZ.tel} className="flex items-center gap-3 font-display text-xl font-extrabold text-white" data-testid="footer-phone-link"><Phone className="h-4 w-4 text-[#FF6B00]" />{BIZ.phone}</a>
          <a href={BIZ.mailto} className="flex items-center gap-3 hover:text-[#FF8533]" data-testid="footer-email-link"><Mail className="h-4 w-4 text-[#FF6B00]" />{BIZ.email}</a>
          <p className="flex items-start gap-3"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#FF6B00]" /><span>{BIZ.address}<br /><span className="text-white/60">{BIZ.addressNote}</span></span></p>
        </div>
        <div className="space-y-3 text-sm text-white/85" data-testid="footer-hours">
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-[#FFB27A]">Opening hours</h4>
          <p className="flex items-center gap-3"><Clock className="h-4 w-4 text-[#FF6B00]" />{BIZ.hours}</p>
          <p className="flex items-center gap-3"><Moon className="h-4 w-4 text-[#FF6B00]" />{BIZ.emergency}</p>
          <p className="pl-7 text-white/60">Servicing all Perth metro suburbs</p>
        </div>
        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-[#FFB27A]">Explore</h4>
          <ul className="grid grid-cols-2 gap-2 text-sm">
            {NAV.map(([id, l]) => <li key={id}><button onClick={() => scrollToId(id)} className="text-white/85 hover:text-[#FF8533]" data-testid={`footer-nav-${id}`}>{l}</button></li>)}
          </ul>
        </div>
      </div>
      <div className="mt-16 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/70 sm:flex-row">
        <p>© {new Date().getFullYear()} {BIZ.legal}. All rights reserved.</p>
        <a href="/admin" data-testid="footer-admin-link" className="hover:text-white">Staff login</a>
      </div>
    </div>
  </footer>
);
